import React from 'react';

/**
 * Floating button that opens the app in a new browser window at full screen.
 * Useful for new joiners to read instructions clearly during onboarding.
 */
export default function FullScreenButton() {
  const handleClick = () => {
    const width = window.screen.availWidth;
    const height = window.screen.availHeight;
    const newWindow = window.open(
      window.location.origin + '/',
      'ITOnboardingFullScreen',
      `width=${width},height=${height},left=0,top=0,menubar=no,toolbar=no,location=no,status=no`
    );
    if (newWindow) {
      newWindow.focus();
    } else {
      alert('Please allow popups for this site to open the full-screen view.');
    }
  };

  return (
    <button
      onClick={handleClick}
      style={{
        position: 'fixed',
        top: 12,
        right: 12,
        zIndex: 9999,
        background: '#009245',
        color: '#fff',
        border: 'none',
        borderRadius: 6,
        padding: '8px 14px',
        fontSize: 15,
        fontWeight: 600,
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(98, 100, 167, 0.3)',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontFamily: "'Segoe UI', -apple-system, sans-serif",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = '#4a4d8c';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(98, 100, 167, 0.5)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = '#009245';
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(98, 100, 167, 0.3)';
      }}
      title="Open in new window at full screen for easier reading"
    >
      ⛶ Full Screen
    </button>
  );
}
